import { useEffect } from 'react';
import { pick, path } from 'ramda';
import { useSelector } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { AUTH_REDUCER } from 'js/store/constants';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import { useQuickDeposit } from './hooks';

export const QuickDepositPopupLauncher = ({ onClose }) => {
    const showLoginPopup = useLoginPopup();
    const { isLoggedIn, role } = useUserSelector(pick(['isLoggedIn', 'role']));
    const isLogoutInProcess = useSelector(path([AUTH_REDUCER, 'isLogoutInProcess']));
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();

    useQuickDeposit({ onClose });

    useEffect(() => {
        if (!isLoggedIn && !isLogoutInProcess && role !== 'admin') {
            showLoginPopup();
        }

        if (isLogoutInProcess) {
            navigateToPopupBackgroundPage();
        }
    }, [isLoggedIn, isLogoutInProcess, role, showLoginPopup, navigateToPopupBackgroundPage]);

    return null;
};
